import { formatDate } from '@angular/common';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Log } from '@s8l/client-tree-lib';

import { AnalyticsMetric, StatsService } from 'src/app/services/stats.service';
import { environment } from 'src/environments/environment';

import { AggregationGroup } from '../../../services/jsonrpc/stats-server.service';
import { HomeWidget } from '../dashboard-widget.utils';

@Component({
  selector: 'app-users-widget',
  templateUrl: './users-peak-date-widget.component.html',
  styleUrls: ['./users-peak-date-widget.component.scss']
})
export class UsersPeakDateWidgetComponent extends HomeWidget implements OnInit {
  public error = false;
  public date: string = null;

  constructor(elRef: ElementRef, private stats: StatsService) {
    super(elRef);
  }

  ngOnInit() {
    this.stats
      .fetchMetrics(
        AnalyticsMetric.active_users,
        this.settings.relative,
        [AggregationGroup.date],
        this.settings.filter,
        this.settings.exclude,
        this.settings.from,
        this.settings.to
      )
      .then(data => {
        const max = data.reduce((prev, curr) => (curr.users > prev.users ? curr : prev), { users: -1, date: '' }).date;
        this.date = max === '' ? '-' : formatDate(new Date(Date.parse(max)), environment.dateFormat, 'en-US');
        this.error = false;
      })
      .catch(err => {
        this.error = true;
        Log.log('UsersPeakDateWidgetComponent', 'Error', err);
      });
  }
}
